import React, { useEffect, useState } from "react";
import "./HelpService.scss";
import PriceTagIcon from '../Assets/icons/pricetag.svg'
import { getSubcategoryWiseContent } from "../services/getSubcategoryWiseContent";
import { ImageLink } from "../constants";

const HelpService = ({ subCategoryID = '',description = '' }) => {
    const [pageData, setPageData] = useState([]);
    const fetchData = async () => {
        await getSubcategoryWiseContent(subCategoryID)
            .then((data) => {
                setPageData(data.multipleBenefitData);
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        fetchData();
    }, [subCategoryID]);

    if(!pageData?.benefitData?.length){
        return null;
    }
    return (
        <div className="container">
        <div className="background-shadow help-service">
            <span>
                <span className="title">{pageData?.mainTitle} </span>
                 <p className="description mt-2">{description || "Smart solutions designed to handle advanced academic challenges effectively"}</p>
            </span>
            <div className="help-service-card-container">
                <div className="help-service-container">
                    {pageData?.benefitData?.map((item, index) => {
                        return <CategoryCard key={index} details={item} />;
                    })}
                </div>
            </div>
        </div>
        </div>
    );
};

const CategoryCard = ({ details }) => {
  return (
    <div className="help-card">
      <div className="help-card-header">
        <img
          className="help-card-icon"
          src={ImageLink(details.image ?? PriceTagIcon)}
          alt={details.title}
        />
        <div className="help-card-title">{details.title}</div>
      </div>

      <hr />

      <div className="help-card-description">
        {details.description}
      </div>
    </div>
  );
};

export default HelpService;
